/**
 * variationNaming — the single naming-truth rule for variation chrome.
 *
 * Versions-first-header (2026-07-09): variations are removed from the primary
 * chrome. The only variation surface that survives is a LEGACY escape hatch —
 * the recipe-kebab "Variations" item, the explorer variation tree, the draft-row
 * + section-rating breadcrumb variation label, and the delete-modal variation
 * clause — and it renders ONLY for recipes that already carry more than one
 * variation. Every one of those gates asks the same question, so it lives here
 * ONCE rather than as drifting inline `> 1` copies.
 *
 * branding.md §8 — "Variation" not "branch"; no phantom names in chrome.
 */

/** Canonical name of the auto-created initial variation. */
export const DEFAULT_VARIATION_NAME = "main";

/**
 * Whether a recipe is a LEGACY multi-variation recipe — i.e. it carries more
 * than one variation and therefore keeps the variation escape-hatch chrome.
 *
 * Accepts either a raw count or anything with a `length` (a variation list).
 * `null` / `undefined` → `false`: an unwired caller shows NO variation chrome,
 * which is the versions-first default (a single-variation recipe — the norm —
 * carries no `main` git-ism to disambiguate).
 */
export function isLegacyMultiVariation(
  countOrList: number | { length: number } | null | undefined,
): boolean {
  if (countOrList == null) return false;
  const count = typeof countOrList === "number" ? countOrList : countOrList.length;
  return count > 1;
}
